import {
  SettingsLayout,
  UserSettingsProfileCard,
  UserSettingsIdentityCard,
  UserSettingsAppearanceCard,
  UserSettingsAuthProviders,
  UserSettingsFeatureFlags,
} from '@backstage/plugin-user-settings';
import { Grid } from '@backstage/ui';
import { useApi } from '@backstage/core-plugin-api';
import { rbacApiRef } from '@backstage-community/plugin-rbac/legacy';
import useAsync from 'react-use/lib/useAsync';
import { Navigate } from 'react-router-dom';


export const UserSettings = () => {
    const rbacApi = useApi(rbacApiRef);
    const { value: rbacAuth } = useAsync(
      () => rbacApi.getUserAuthorization(),
      [],
    );
    const isRbacAdmin = rbacAuth?.status === 'Authorized';

    return (
    <SettingsLayout title="Settings">
      <SettingsLayout.Route path="/" title="General">
        <Grid.Root columns="12" gap="3">
            <Grid.Item colSpan={{ xs:'12', md: '6' }}>
                <UserSettingsProfileCard />
            </Grid.Item>
            <Grid.Item colSpan={{ xs:'12', md: '6' }}>
                <UserSettingsIdentityCard />
            </Grid.Item>
            <Grid.Item colSpan={{ xs:'12', md: '6' }}>
                <UserSettingsAppearanceCard />
            </Grid.Item>
        </Grid.Root>
      </SettingsLayout.Route>

      <SettingsLayout.Route path="/auth-providers" title="Authentication">
        <UserSettingsAuthProviders />
      </SettingsLayout.Route>

      <SettingsLayout.Route path="/feature-flags" title="Feature Flags">
        <UserSettingsFeatureFlags />
      </SettingsLayout.Route>

      {isRbacAdmin && (
        <SettingsLayout.Route path="/rbac" title="RBAC">
          <Navigate to="/rbac" replace />
        </SettingsLayout.Route>
      )}
    </SettingsLayout>
    )
};